<template>
  <form-component
    class="giveaway-form"
    method="post"
    @submit.prevent="handleEnteringGiveaway"
  >
    <text-input
      id="email"
      v-model="email"
      exclude-label
      placeholder="Enter your email"
      class="giveaway-form__input text-input--full-width"
      required
      name="email"
      input-type="email"
    />
    <button-component
      type="submit"
      class="giveaway-form__button button--block"
      button-type="giveaway"
    >Enter giveaway</button-component>
    <p class="disclaimer-text">
      By providing your email address, you are agreeing to our
      <a
        href="/living/terms-and-conditions"
        target="_blank"
        rel="noopener"
      >Giveaway Terms & Conditions</a>,
      <a
        href="https://health-union.com/privacy-policy/"
        target="_blank"
        rel="noopener"
      >Privacy Policy</a>,
      and
      <a
        href="https://health-union.com/terms-of-use/"
        target="_blank"
        rel="noopener"
      >Terms of Use</a>.
    </p>
  </form-component>
</template>

<script>
import { GENERATE_LEAD } from '@/graphql/mutations/lead-gen-mutations';
import ButtonComponent from '@/components/Global/ButtonComponent.vue';
import TextInput from '@/components/Inputs/TextInput.vue';
import dataLayerMixin from '@/mixins/data-layer-mixin';

export default {
  name: 'GiveawayForm',
  components: {
    ButtonComponent,
    TextInput,
  },
  mixins: [dataLayerMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      email: '',
    };
  },
  computed: {
    contentType() {
      return this.$route.name === 'forums' ? 'forums' : 'post';
    },
  },
  methods: {
    handleEnteringGiveaway() {
      this.$apollo.mutate({
        mutation: GENERATE_LEAD,
        variables: {
          campaign: this.data.question,
          email: this.email,
          form: 'giveaway',
          pageviewId: this.$store.getters.pageViewId,
          contentType: this.contentType,
          medium: 'Site',
        },
      }).then(({ data }) => {
        if (data?.generateLead.discardReason === 'DUPLICATE_GIVEAWAY_ENTRY') {
          this.$emit('submitted', 'duplicateEntry');
          return;
        }
        this.$emit('submitted', 'success');
      }).catch(() => {
        this.$store.dispatch('addToastNotification', {
          toastType: 'error',
          description: 'There was a problem submitting your entry.  Please try again.',
        });
        this.$logger.warn('problem submitting new lead.');
      });

      this.$store.dispatch('setUserHasSubscribed', true);
      this.setDataLayer();
      this.pushDataLayer();
      this.setTrackingInAC(this.email);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_giveaway-form';
</style>
